import api from '@pray/shared/utils/api';

/**
 * Fetch subscriber statistics (aggregate counts)
 *
 * Returns accurate total, active, cancelled, and trial counts
 * directly from the database without pagination.
 *
 * @param {Object} options
 * @param {string} options.artistId - Artist ID (required)
 * @param {string} [options.startDate] - Start date ISO string (optional)
 * @param {string} [options.endDate] - End date ISO string (optional)
 * @returns {Promise<{ total: number, active: number, cancelled: number, trial: number, totalRevenue: number, avgSubscriptionAmount: number }>}
 */
export async function getSubscriberStats({ artistId = '', startDate = '', endDate = '' }) {
  if (!artistId) throw new Error('Artist ID is required');

  const params = {};

  if (startDate) {
    params.start_date = startDate;
  }
  if (endDate) {
    params.end_date = endDate;
  }

  const url = `/web/studio/artists/${artistId}/givingPayments/subscribers/stats`;
  const response = await api.executeGetRequest(url, params);

  // sendSuccessResponse wraps data as: { data: [{ resource: { ...stats } }] }
  const resource = response?.data?.data?.[0]?.resource;
  return resource || response.data;
}
